import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";

export const useVocabStore = defineStore(
  "vocab",
  () => {
    const state = reactive({
      forceDeleteWord: false
    });

    const setForceDeleteWord = (value = true) => {
      state.forceDeleteWord = value;
    };

    return {
      ...toRefs(state),

      setForceDeleteWord
    };
  },
  {
    persist: {
      paths: ["forceDeleteWord"]
    }
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVocabStore, import.meta.hot));
}
